// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RD2CmKQFZKidd6 {
  display: flex;
  z-index: 1;
  flex: 1 1 auto;
  flex-direction: column;
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px);
  padding: var(--ds-space-050, 4px);
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
  row-gap: 8px;
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translate3d(0, 0, 0);
  scrollbar-color: var(--ds-background-neutral-hovered, #091e4224) var(--ds-background-neutral, #091e420f);
  scrollbar-width: thin;
}
.RD2CmKQFZKidd6.nDXj3TuYucoGm4 {
  row-gap: var(--ds-space-0, 0);
  margin-top: var(--ds-space-negative-050, -4px);
}
[data-drag-preview] .RD2CmKQFZKidd6 {
  /* stylelint-disable-next-line declaration-no-important */
  overflow-y: hidden !important;
}
.RD2CmKQFZKidd6[hidden] {
  display: none;
}
.RD2CmKQFZKidd6::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.RD2CmKQFZKidd6::-webkit-scrollbar-button:start:decrement,
.RD2CmKQFZKidd6::-webkit-scrollbar-button:end:increment {
  display: none;
  background: transparent;
}
.RD2CmKQFZKidd6::-webkit-scrollbar-track-piece {
  background: var(--ds-background-neutral, #091e420f);
}
.RD2CmKQFZKidd6::-webkit-scrollbar-track-piece:vertical:start {
  border-radius: 4px 4px 0 0;
}
.RD2CmKQFZKidd6::-webkit-scrollbar-track-piece:vertical:end {
  border-radius: 0 0 4px 4px;
}
.RD2CmKQFZKidd6::-webkit-scrollbar-track-piece:horizontal:start {
  border-radius: 4px 0 0 4px;
}
.RD2CmKQFZKidd6::-webkit-scrollbar-track-piece:horizontal:end {
  border-radius: 0 4px 4px 0;
}
.RD2CmKQFZKidd6::-webkit-scrollbar-thumb:vertical,
.RD2CmKQFZKidd6::-webkit-scrollbar-thumb:horizontal {
  display: block;
  height: 48px;
  border-radius: 4px;
  background: var(--ds-background-neutral-hovered, #091e4224);
}
.RD2CmKQFZKidd6::-webkit-scrollbar-button:end {
  display: block;
  width: 4px;
  height: 4px;
}
@-moz-document url-prefix() {
  .RD2CmKQFZKidd6 {
    margin-right: var(--ds-space-0, 0);
    padding-right: var(--ds-space-100, 8px);
  }
}
.Ddjfff57W7abTr {
  display: none;
  flex-shrink: 0;
  height: 8px;
  margin-bottom: var(--ds-space-negative-050, -4px);
}
.Ddjfff57W7abTr[hidden] {
  /* stylelint-disable-next-line declaration-no-important */
  display: none !important;
}
@supports (selector(:has(*))) {
  .Ddjfff57W7abTr:has( + .RD2CmKQFZKidd6 > *:not([hidden])) {
    display: block;
  }
}
@supports not (selector(:has(*))) {
  .Ddjfff57W7abTr {
    display: block;
  }
}
.bEMhY1eji5ORUy {
  margin-top: 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listCards": `RD2CmKQFZKidd6`,
	"hoverGapEnabled": `nDXj3TuYucoGm4`,
	"topBuffer": `Ddjfff57W7abTr`,
	"lastDropPreview": `bEMhY1eji5ORUy`
};
export default ___CSS_LOADER_EXPORT___;
